import { DropboxCreatedGuard } from '@app/core/guards/dropbox-created-guard.guard';
import { PrepareGuard } from '@app/core/guards/prepare-guard.guard';
import { SendGuard } from '@app/core/guards/send-guard.guard';
import { LandingComponent } from '../modules/landing/landing.component';
import { PrepareComponent } from '../modules/prepare/prepare.component';
import { SendComponent } from '../modules/send/send.component';
import { UploaderStandardComponent } from './uploader-standard.component';
import { uploaderStandardRouteNames } from './uploader-standard.routes.names';
import { Routes } from '@angular/router';
import { DropboxPrepareGuard } from '@app/core/guards/dropbox-prepare-guard.guard';
import { DropboxSendGuard } from '@app/core/guards/dropbox-send-guard.guard';
import { DropboxUploaderGuard } from '@app/core/guards/dropbox-uploader.guard';

export const UPLOADER_STANDARD_ROUTES: Routes = [
    {
        path: uploaderStandardRouteNames.EMPTY_URL,
        component: UploaderStandardComponent,
        children: [
            {
                path: uploaderStandardRouteNames.EMPTY_URL,
                component: LandingComponent,
            },
            {
                path: uploaderStandardRouteNames.PREPARE,
                component: PrepareComponent,
                canActivate: [PrepareGuard],
            },
            {
                path: uploaderStandardRouteNames.SEND,
                component: SendComponent,
                canActivate: [SendGuard],
                canDeactivate: [SendGuard],
            },
            {
                path: uploaderStandardRouteNames.DROPBOX_CREATED,
                component: SendComponent,
                canActivate: [DropboxCreatedGuard],
            },
        ]
    },
    {
        path: uploaderStandardRouteNames.DROPBOX_PREFIX,
        canActivate: [DropboxUploaderGuard],
        component: UploaderStandardComponent,
        children: [
            {
                path: uploaderStandardRouteNames.DROPBOX_LANDING,
                pathMatch: 'full',
                component: LandingComponent,
            },
            {
                path: uploaderStandardRouteNames.DROPBOX_PREPARE,
                pathMatch: 'full',
                component: PrepareComponent,
                canActivate: [DropboxPrepareGuard],
            },
            {
                path: uploaderStandardRouteNames.DROPBOX_SEND,
                pathMatch: 'full',
                component: SendComponent,
                canActivate: [DropboxSendGuard],
                canDeactivate: [DropboxSendGuard],
            },
        ]
    }
];
